
import styled from "styled-components";
import { colors } from "./colors/color";

export type variants = 'success' | 'warning' | 'error' | 'info';

type MessageProps = {
    variant: variants,
    hide?: boolean,
    textAlign?: 'left' | 'center' | 'right',
    padding?: string,
    grow?: 0 | 1 | 2
}

const handleMessageType = (type: variants) => {
    switch (type) {
        case "info":
            return`border-color: ${colors.messageCard.info.border}; `;
        case "success":
            return `border-color: ${colors.messageCard.success.border};`;
        case "warning":
            return `border-color: ${colors.messageCard.warning.border}; `;
        case "error":
            return `border-color: ${colors.messageCard.error.border};`;
    }
};

export const MessageCard = styled.div<MessageProps>`
    background-color: white;
    border: 1px solid;
    border-radius: 4px;
    border-left: 5px solid;
    color: ${colors.text.normal};
    flex-grow: ${props => props.grow || 0};
    text-align: ${props => props.textAlign || 'center'};
    ${({ variant: type }) => handleMessageType(type)};
    overflow-wrap: break-word;
    white-space: pre-wrap;
    visibility: ${ props => props.hide ? 'hidden' : 'visible' };
    padding: ${props => props.padding || '10px'};
`;


    

export const ErrorMessage = styled.div<{ show?: boolean }>`
    background-color: #fff;
    opacity: ${({ show }) => show ? '1' : '0'};
    height: ${({ show }) => show ? 'initial' : '0'};
    border-left: 5px solid black;
    ${ props => props.show && "padding:10px"};
    text-align: center;
    transition: opacity 0.5s ease-in, height 0.25s ease-out;
    ${handleMessageType('error')}
`;